import type {
  AuditLog,
  AuthLoginResponse,
  CurrentTenantResponse,
  Invitation,
  Member,
  PaginatedResponse,
  Role,
  Tenant,
} from "@chat-yai/shared";
import { request } from "@/api/client";

export const tenantsApi = {
  create(input: { slug: string; name: string }) {
    return request<{ tenant: Tenant }>("/admin/tenants", {
      method: "POST",
      body: input,
    });
  },
  current() {
    return request<CurrentTenantResponse>("/admin/tenants/current");
  },
  switch(input: { tenant_id: string }) {
    return request<AuthLoginResponse>("/admin/tenants/switch", {
      method: "POST",
      body: input,
    });
  },
  updateCurrent(input: { name?: string; slug?: string }) {
    return request<{ tenant: Tenant }>("/admin/tenants/current", {
      method: "PATCH",
      body: input,
    });
  },
  members() {
    return request<{ members: Member[] }>("/admin/tenants/current/members");
  },
  updateMember(userId: string, input: { role: Role }) {
    return request<{ ok: true }>(`/admin/tenants/current/members/${userId}`, {
      method: "PATCH",
      body: input,
    });
  },
  removeMember(userId: string) {
    return request<{ ok: true }>(`/admin/tenants/current/members/${userId}`, {
      method: "DELETE",
    });
  },
  leave() {
    return request<{ ok: true }>("/admin/tenants/current/members/leave", {
      method: "POST",
    });
  },
  invitations(query: { status?: string } = {}) {
    return request<{ invitations: Invitation[] }>(
      "/admin/tenants/current/invitations",
      { query },
    );
  },
  createInvitation(input: { email: string; role: Role }) {
    return request<{ invitation: Invitation }>(
      "/admin/tenants/current/invitations",
      { method: "POST", body: input },
    );
  },
  revokeInvitation(id: string) {
    return request<{ ok: true }>(`/admin/tenants/current/invitations/${id}`, {
      method: "DELETE",
    });
  },
  acceptInvitation(token: string) {
    return request<{ tenant_id: string }>(`/admin/invitations/${token}/accept`, {
      method: "POST",
    });
  },
  auditLogs(query: {
    action?: string;
    from?: string;
    to?: string;
    page?: number;
    page_size?: number;
  }) {
    return request<PaginatedResponse<AuditLog>>("/admin/tenants/current/audit-logs", {
      query,
    });
  },
};
